module.exports = __webpack_public_path__ + "static/img/4_1_3.9462c258.png";